import { AuthAction, AuthActionTypes, AuthState } from './auth.types';

export const authReducer = (
  state: AuthState,
  action: AuthAction,
): AuthState => {
  switch (action.type) {
    case AuthActionTypes.SET_USER:
      return {
        ...state,
        user: action.payload,
        loading: false,
      };

    case AuthActionTypes.LOGOUT:
      return {
        ...state,
        user: null,
        loading: false,
      };

    case AuthActionTypes.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
};
